import { ServiceCard } from './ServiceCard';
import { SERVICES_SECTIONS } from './ServicesSectionList';

export const ServicesSection = () => {
  return (
    <div id="servicos">
      {SERVICES_SECTIONS.map((service) => (
        <ServiceCard key={service.id} service={service} />
      ))}
    </div>
  );
};
